import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import PodCardHeader from './PodCardHeader'
import PodCardBody from './PodCardBody'
import ConfirmDeletePodModal from './ConfirmDeletePodModal'
import Modal from '../common/Modal'
import { podType } from '../common/types'

const PodCardContainer = styled.div`
  flex-basis: 30%;
  background-color: #f7f7f7;
  border-radius: 2px;
  border-top: 5px solid #2b86c0;
  box-shadow: 1px 2px 1px #f1f1f1;
  margin-bottom: 20px;
  box-shadow: 0 2px 4px 0 rgba(0,0,0,0.11);
`

class PodCard extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isDeleteModalOpen: false
    }
  }
  onDeleteModalToggle = () => {
    this.setState({ isDeleteModalOpen: !this.state.isDeleteModalOpen })
  }
  onEditClick = () => {
    const { onPodEdit, pod: { rid } } = this.props
    onPodEdit({ rid })
  }
  render() {
    const { isDeleteModalOpen } = this.state
    const { pod } = this.props
    const { name, admins } = pod
    return (
      <PodCardContainer>
        <PodCardHeader onDeleteModalOpen={this.onDeleteModalToggle} name={name} onEditClick={this.onEditClick} />
        <PodCardBody admins={admins} />
        <Modal light isModalOpen={isDeleteModalOpen}>
          <ConfirmDeletePodModal onCancel={this.onDeleteModalToggle} pod={pod} />
        </Modal>
      </PodCardContainer>
    )
  }
}

PodCard.propTypes = {
  onPodEdit: PropTypes.func.isRequired,
  pod:       podType
}

export default PodCard
